import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Tables } from "@/lib/supabase/supabase_types_override";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";

type Props = {
    question: Tables<'question'> | Tables<'question'> & { dependent_questions?: Tables<'question'>[] };
    onEditQuestion: (questionId: Tables<'question'>['id']) => void;
    onRemoveQuestion: (questionId: Tables<'question'>['id']) => void;
}

export const QuestionRow = ({
    question,
    onEditQuestion,
    onRemoveQuestion
}: Props) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="border border-input rounded-md py-1 px-3 flex justify-between items-center bg-gray-100">
                <div className="flex flex-col gap-1">
                    <div className="flex gap-2 items-center">
                        <div className="text-sm font-semibold">Question: {question.question}</div>
                        <div className="capitalize text-xs italic">&#40;Type: {question.field_type}&#41;</div>
                    </div>

                    <div className="text-xs">Description: {question.description || "-"}</div>
                </div>


                <div>
                    <TooltipProvider>
                        <div className="flex justify-center w-full gap-1">
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        type="button"
                                        size='action'
                                        className={`text-nowrap flex text-sm`}
                                        onClick={() => onEditQuestion(question.id)}
                                    >
                                        <Pencil size={16}/>
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Edit</p>
                                </TooltipContent>
                            </Tooltip>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Button
                                        type="button"
                                        variant="destructive"
                                        size='action'
                                        className={`text-nowrap flex text-sm`}
                                        onClick={() => onRemoveQuestion(question.id)}
                                    >
                                        <Trash2 size={16}/>
                                    </Button>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>Delete</p>
                                </TooltipContent>
                            </Tooltip>
                        </div>
                    </TooltipProvider>
                </div>
            </div>
            {question.dependent_questions?.length > 0 && (
                <div className="pl-2 ml-2 border-l-[1px] border-gray-300 flex flex-col gap-2">
                    {question.dependent_questions.map((dependentQuestion) => (
                        <QuestionRow 
                            key={dependentQuestion.id}
                            question={dependentQuestion}
                            onEditQuestion={onEditQuestion}
                            onRemoveQuestion={onRemoveQuestion}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
